/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-content[_ngcontent-%COMP%]   .conditions[_ngcontent-%COMP%] {\n  overflow: scroll;\n  margin-bottom: 25px;\n}"];
export { styles as styles };
